
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_r2vco_53vq5_141",
  "dropdown-header": "awsui_dropdown-header_r2vco_53vq5_173",
  "dropdown-footer": "awsui_dropdown-footer_r2vco_53vq5_179"
};
  